import FormattedMessage from 'I18n/components/FormattedMessage';
import { Component } from 'react';
import { DragSource } from 'react-dnd-compat';
import WidgetIcon from 'ContentComponents/components/cmv2/WidgetIcon';
import { DRAG_TYPES } from 'ContentEditorUI/utils/DragAndDropConstants';
import EPAddableTile from 'editor-components/sidebar/addableComponents/EPAddableTile';
import EPAddableObject from 'editor-components/sidebar/addableComponents/EPAddableObject';
import { Ribbon } from 'foundations-components/transitional/components/Ribbon';
import { noop } from 'underscore';
import { WigglyAnimation } from './WigglyAnimation';
import { LockedIcon } from 'foundations-assets/icons/components/LockedIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PATAGONIA_ICON_SIZE = 20;
const PATAGONIA_TILE_SIZE = 80;
const PATAGONIA_TEXT_SIZE = 11;
const PATAGONIA_ADDABLE_OBJECT_MAX_CHARS = 20;
export const DRAGGABLE_ITEM_TYPES = {
  TILE: 'TILE',
  OBJECT: 'OBJECT'
};
const moduleSource = {
  beginDrag(props) {
    const dragPayload = {
      widgetCid: props.schema.id || props.schema.name,
      type: props.type,
      widgetLabel: props.schema.label,
      widgetPath: props.schema.path,
      isThemeAsset: props.schema.isThemeAsset
    };
    if (props.onDragStart) props.onDragStart(dragPayload);
    return dragPayload;
  },
  endDrag(props, monitor) {
    const dropResult = monitor.getDropResult();
    const dragItem = monitor.getItem();
    if (!monitor.didDrop() && props.onDragEnd) {
      props.onDragEnd(undefined, dragItem);
      return;
    }
    if (props.onDragEnd) props.onDragEnd(dropResult, dragItem);
  }
};
const Draggable = DragSource(DRAG_TYPES.ADD_MODULE, moduleSource, monitor => ({
  isDragging: monitor.isDragging()
}));
class DraggableTile extends Component {
  constructor(props) {
    super(props);
    this._icon = null;
    this.toggleWiggleTile = () => {
      this.setState({
        isWiggly: !this.state.isWiggly
      });
    };
    this.state = {
      isWiggly: false
    };
  }
  renderIcon(size) {
    const {
      schema
    } = this.props;
    // TODO switch to using getIconForModule util?
    if (schema.icon || schema.schemaVersion === 2) {
      return /*#__PURE__*/_jsx(WidgetIcon, {
        size: size,
        color: "icon-core-subtle",
        icon: schema.icon
      });
    }
    return null;
  }
  renderBaymaxAddableObject() {
    const {
      schema,
      hideTooltips,
      sidebarIframeBody,
      disabled
    } = this.props;
    return /*#__PURE__*/_jsx(EPAddableObject, {
      useOnDark: true,
      _bodyElement: sidebarIframeBody,
      iconNode: this.renderIcon(20),
      text: schema.displayName,
      hideTooltip: hideTooltips,
      maxChars: PATAGONIA_ADDABLE_OBJECT_MAX_CHARS,
      disabled: disabled
    });
  }
  renderPatagoniaAddableTile() {
    const {
      sidebarIframeBody,
      schema,
      hideTooltips,
      isDragging,
      disabled
    } = this.props;
    const {
      isWiggly
    } = this.state;
    return /*#__PURE__*/_jsx(WigglyAnimation, {
      $animationName: "clickTileItem",
      $isWiggly: isWiggly && !disabled,
      onClick: () => this.toggleWiggleTile(),
      onAnimationEnd: () => this.toggleWiggleTile(),
      children: /*#__PURE__*/_jsx(EPAddableTile, {
        useOnDark: true,
        _bodyElement: sidebarIframeBody,
        iconNode: this.renderIcon(PATAGONIA_ICON_SIZE),
        text: schema.displayName,
        hideTooltip: hideTooltips,
        isDragging: isDragging,
        disabled: disabled,
        tileSize: PATAGONIA_TILE_SIZE,
        textSize: PATAGONIA_TEXT_SIZE,
        boxShadow: "100",
        hoverStyleTokens: {
          boxShadow: '300'
        }
      })
    });
  }
  getDraggableElement() {
    const {
      draggableItemType
    } = this.props;
    if (draggableItemType === DRAGGABLE_ITEM_TYPES.TILE) {
      return this.renderPatagoniaAddableTile();
    } else if (draggableItemType === DRAGGABLE_ITEM_TYPES.OBJECT) {
      return this.renderBaymaxAddableObject();
    }
    return null;
  }
  render() {
    const {
      connectDragSource,
      schema,
      isDraggable,
      useLockedRibbon,
      useNewRibbon,
      disabled
    } = this.props;
    let ribbonType;
    if (useLockedRibbon) {
      ribbonType = 'candy-apple';
    } else if (useNewRibbon) {
      ribbonType = 'new';
    }
    const showRibbon = useLockedRibbon || useNewRibbon;
    const liElement = /*#__PURE__*/_jsxs("li", {
      "data-hs-dragdrop": true,
      "data-widget-id": schema.id || schema.name,
      "data-test-widget-name": schema.name && schema.name,
      onMouseDown: showRibbon ? this.props.onMouseDown : noop,
      children: [showRibbon && /*#__PURE__*/_jsxs(Ribbon, {
        cursor: useNewRibbon ? 'grab' : 'default',
        use: ribbonType,
        children: [useLockedRibbon && /*#__PURE__*/_jsx(LockedIcon, {
          alignWithText: true,
          size: "200"
        }), !useLockedRibbon && useNewRibbon &&
        /*#__PURE__*/
        // @bend-expect trellis-tokenized
        _jsx("span", {
          style: {
            fontSize: '10px'
          },
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "addModule.newBanner"
          })
        })]
      }), this.getDraggableElement()]
    });
    if (isDraggable && !disabled && connectDragSource) {
      return connectDragSource(liElement);
    }
    return liElement;
  }
}

// Need a hook into the component without the react-dnd wrapper, in order to deal with
// timing issues when forcing rendering of "fake" components in InpageSidebarPortal (prior
// to copying styled component styles over)
DraggableTile.defaultProps = {
  isDraggable: true,
  style: {}
};
export const UnwrappedDraggableTile = DraggableTile;
export default Draggable(DraggableTile);